import { useEffect, useState } from "react";

import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import ReactPlayer from "react-player";
import CircularProgressWithLabel from "./ProgressWithLabel";
import { baseUrl, uploaderType } from "../utils/config";
import { getToken } from "../utils/API/authMethods";
import DeleteIcon from "@mui/icons-material/Delete";
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function VideoUploader({
  endpoint,
  type,
  label,
  onChange,
  previewStyle,
  defaultSrc,
  values,
  error,
  helperText,
}) {
  // State variables for the file and the current chunk index
  const [file, setFile] = useState(null);
  const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
  const [complete, setComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [videoQuality, setVideoQuality] = useState(
    (type === uploaderType.video && values.res_1080) || null
  );

  const handleCancele = () => {
    setFile(null);
    setLoading(false);
  };

  // Constant for the chunk size (5MB)
  const chunkSize = 1024 * 1024 * 0.5;

  // Function to handle the start of the upload
  function handleUpload(e) {
    // e.preventDefault();
    setLoading(true);
    setCurrentChunkIndex(0);
  }

  // useEffect hook to handle the file upload
  useEffect(() => {
    // Function to upload a chunk of the file
    async function uploadChunk(readerEvent) {
      if (!file) return;
      const data = readerEvent.target.result;

      // Set up the parameters for the request
      const params = new URLSearchParams();
      params.set("name", file.name);
      params.set("currentChunkIndex", currentChunkIndex);
      params.set("totalChunks", Math.ceil(file.size / chunkSize));
      params.set("authorization", getToken());

      //Установим старое имя в параметры запроса, для удаления старого файла
      defaultSrc && params.set("oldName", defaultSrc);

      // Set up the headers for the request
      const headers = {
        "Content-Type": "application/octet-stream",
        Authorization: `Bearer ${getToken()}`,
      };
      const url = `${baseUrl}/${endpoint}?` + params.toString();

      // Make the POST request to the server
      fetch(url, {
        method: "POST",
        headers: headers,
        body: data,
      })
        .then((response) => response.json())
        .then((res) => {
          // Check if this is the last chunk
          const isLastChunk =
            currentChunkIndex === Math.ceil(file.size / chunkSize) - 1;
          // If it is, set the final filename and reset the current chunk index
          if (isLastChunk) {
            file.finalFilename = res.finalFilename;
            file.fileSize = res.fileSize;
            file.duration = res.videoDuration;
            file.compressedVideos = res.compressedVideos;
            type == uploaderType.video &&
              setVideoQuality(res.compressedVideos[1080]);
            // setVideoQuality(Object.entries(res.compressedVideos)[0][0]);
            setComplete(true);
            setCurrentChunkIndex(null);
            // values.video_src = file.finalFilename;
            // values.video_length = file.fileSize;
            onChange(file);
          } else {
            // If it's not, increment the current chunk index
            setCurrentChunkIndex(currentChunkIndex + 1);
          }
        });
    }

    // Function to read and upload the current chunk
    function readAndUploadCurrentChunk() {
      if (!file) return;
      // Calculate the start and end of the current chunk
      const from = currentChunkIndex * chunkSize;
      const to =
        (currentChunkIndex + 1) * chunkSize >= file.size
          ? file.size
          : from + chunkSize;

      // Slice the file to get the current chunk
      const blob = file.slice(from, to);

      const reader = new FileReader();
      // Set the onload function to upload the chunk when it's read
      reader.onload = (e) => uploadChunk(e);
      // Read the blob as a data URL
      reader.readAsDataURL(blob);
    }

    // If a chunk index is set, read and upload the current chunk
    if (currentChunkIndex != null) readAndUploadCurrentChunk();
  }, [chunkSize, currentChunkIndex, file]);

  // Render the component
  return (
    <div
      //   className={"main"}
      style={{
        backgroundColor: "#dedede",
        borderRadius: "0.5rem",
        // border: "1px solid red",
        border: !!error ? "1px solid red" : "none",
        width: "100%",
        height: "225px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        // gap: "20px",
      }}>
      <div
        className="files"
        style={{
          width: "100%",
          height: "auto",
          borderRadius: "0.5rem",
          display: "flex",
          justifyContent: "center",
        }}>
        {(complete || defaultSrc) &&
          (type == uploaderType.video ? (
            <>
              <div
                style={{
                  position: "absolute",
                  flexDirection: "row",
                  zIndex: 6,
                }}>
                {[values.res_480, values.res_720, values.res_1080] &&
                  Object.entries({
                    480: values.res_480,
                    720: values.res_720,
                    1080: values.res_1080,
                  }).map((key) => {
                    const handleQualityChange = () => {
                      setVideoQuality(key[1]);
                    };

                    const buttonVariant =
                      key[1] === videoQuality ? "contained" : "outlined";

                    return (
                      <Button
                        size="small"
                        variant={buttonVariant}
                        onClick={handleQualityChange}>
                        {key[0]}
                      </Button>
                    );
                  })}
              </div>
              <ReactPlayer
                style={{ borderRadius: "20px" }}
                width={320}
                height={"auto"}
                url={
                  // `${baseUrl}${basePort}/video/` + "dc959e_1080p.mp4" ||
                  `${baseUrl}/video/` + videoQuality
                }
                controls={true}
                config={{
                  file: { attributes: { controlsList: "nodownload" } },
                }}
                onError={(err) => {
                  console.log(err);
                }}
                playing={false}
                onContextMenu={(e) => e.preventDefault()}
              />
            </>
          ) : (
            <>
              <img
                src={`${baseUrl}/${endpoint}/${
                  (complete && file.finalFilename) || defaultSrc
                }`}
                alt=""
                style={previewStyle || { height: "180px" }}
              />
            </>
          ))}
      </div>
      {!complete && file && (
        <>
          <CircularProgressWithLabel
            value={
              Math.round(
                (currentChunkIndex / Math.ceil(file.size / chunkSize)) * 100
              ) || 0
            }
          />
        </>
      )}
      {(file && !complete && (
        <Button
          sx={{ marginTop: "20px" }}
          component="label"
          variant="outlined"
          tabIndex={-1}
          onClick={handleCancele}
          startIcon={<CloudOffIcon />}>
          Отменить загрузку
        </Button>
      )) || (
        <Button
          component="label"
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudUploadIcon />}
          disabled={loading}>
          {label}
          <VisuallyHiddenInput
            type="file"
            accept={type === uploaderType.video ? "video/*" : "image/*"}
            onChange={(e) => {
              setFile(e.target.files[0]);
              handleUpload();
            }}
            // multiple
          />
        </Button>
      )}

      {/* // ) : (
        //   <Button
        //     variant="contained"
        //     startIcon={<CloudUploadIcon />}
        //     onClick={handleUpload}
        //     disabled={file.finalFilename}>
        //     Отправить
        //   </Button>
        // ))} */}
      <span
        style={{
          color: "red",
          // position: "absolute",
          paddingTop: "30px",
        }}>
        {helperText}
      </span>
    </div>
  );
}
